'use client';

import React from 'react';

interface TwoColumnLayoutProps {
  mainContent: React.ReactNode;
  sidebar: React.ReactNode;
  className?: string;
}

export function TwoColumnLayout({ mainContent, sidebar, className }: TwoColumnLayoutProps) {
  return (
    <div className={`relative flex flex-col md:flex-row md:space-x-1 h-full ${className || ''}`}>
      {/* Main content column - independently scrollable */}
      <div className="flex-1 h-full overflow-y-auto scrollbar-hide" id="main-content">
        {mainContent}
      </div>

      {/* Sidebar column - independently scrollable with fixed width */}
      <div
        className="h-full overflow-y-auto scrollbar-hide overflow-x-hidden w-full md:w-80 lg:w-96 shrink-0"
        id="sidebar-content"
      >
        {sidebar}
      </div>
    </div>
  );
}
